module.exports = __webpack_public_path__ + "img/Social Networker.3316dda9.svg";